module.exports = __webpack_public_path__ + "static/incidences-hero-1-db915f4872371037dfb5910939ff687a.png";